import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function FinalCta() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative py-24 md:py-32 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 bg-cover bg-center opacity-[0.18] grain"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=1600&q=80')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/95 to-background" />

      <div className="relative max-w-[1100px] mx-auto px-6 md:px-12 text-center">
        <p className="text-[11px] uppercase tracking-[0.28em] text-oxblood font-medium mb-6">
          — One more thing
        </p>
        <h2
          data-testid="final-cta-heading"
          className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-balance max-w-3xl mx-auto"
        >
          Run your wardrobe like the{" "}
          <span className="italic text-oxblood">archive</span> it is.
        </h2>
        <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-xl mx-auto">
          Start your 14-day free trial. No credit card. Cancel anytime.
        </p>

        <div className="mt-10 flex justify-center">
          <Button
            asChild
            size="lg"
            data-testid="final-cta-button"
            className="bg-oxblood hover:bg-oxblood-deep text-ivory rounded-none h-12 px-8 group"
          >
            <Link to="/signup" className="inline-flex items-center gap-2">
              Start 14-Day Free Trial
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
